<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid manage-users">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Admin tools system users</h4>
            <PasswordCheckMessage v-if="passwordCheckFailed" />
            <SuccessMessage class="mt-4" v-if="this.$route.params.success === true" />
            <router-link to="/manage-users/create-user">
              <button class="btn btn-primary mt-2">Create system user</button>
            </router-link>

            <hr />

            <div class="d-flex justify-content-between">
              <div class="d-inline-flex justify-content-between col-md-2">
                <div class="mt-1">
                  <label class="form-label">Show </label>
                </div>
                <div class="ms-2">
                  <select class="form-select form-select-sm form-control" v-model.number="perPage" @change="getUsers">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div class="ms-2 mt-1"><label>entries</label></div>
              </div>

              <div class="col-md-4">
                <input type="search" class="form-control" placeholder="Search" v-model="searchTerm" id="searchBar" @input="searchUsers" />
              </div>
            </div>

            <div class="mt-3 table-responsive">
              <table class="table table-bordered border-light">
                <thead>
                  <tr>
                    <th scope="col">User number</th>
                    <th scope="col" @click="sortUsers()" style="cursor: pointer">
                      Full name
                    </th>
                    <th scope="col">Email</th>
                    <th scope="col">Username</th>
                    <th scope="col">Password</th>
                    <th scope="col">SAM Context</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading === true">
                    <div>
                      <div class="centered">
                        <a-spin />
                      </div>
                    </div>
                  </tr>

                  <tr v-for="user in this.allUsers.Result" :key="user.id" v-else>
                    <td>{{ user.id }}</td>
                    <td class="">
                      {{ user.full_name }}
                    </td>

                    <td>
                      {{ user.email }}
                    </td>

                    <td>
                      {{ user.username }}
                    </td>

                    <td>
                      {{ user.password }}
                    </td>

                    <td>
                      {{ user.sam_context }}
                    </td>

                    <td>
                      <router-link
                        :to="{
                          name: 'EditSystemUser',
                          params: {
                            Id: user.id,
                          },
                        }"
                      >
                        <button type="button" class="btn btn-primary">
                          Edit
                        </button>
                      </router-link>
                    </td>
                    <td>
                      <button type="button" class="btn btn-danger " @click="deleteUser(user.id)" style="color: white;">
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-between">
                <div>
                  <span v-if="allUsers.Result === null">Showing 0 to 0 of 0 entries</span>
                  <span v-else
                    >Showing {{ (currentPage - 1) * allUsers.pageSize + 1 }} to
                    {{ (currentPage - 1) * allUsers.pageSize + allUsers.selectedRecordCount }}
                    of {{ allUsers.totalRecords }} entries</span
                  >
                </div>
                <div class="" v-if="allUsers.Result">
                  <pagination
                    :data="allUsers.Result"
                    :totalPages="Math.ceil(allUsers.totalRecords / perPage)"
                    :total="allUsers.totalRecords"
                    :perPage="perPage"
                    :currentPage="currentPage"
                    @pagechanged="onPageChange"
                  />
                </div>
              </div>
            </div>

            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Pagination from '@/components/Pagination.vue';
import divvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';
import SuccessMessage from './SuccessMessage.vue';
import PasswordCheckMessage from './PasswordCheckMessage.vue';

export default {
  name: 'ManageUsers',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    pagination: Pagination,
    SuccessMessage,
    PasswordCheckMessage,
  },
  data() {
    return {
      loading: false,
      searchTerm: '',
      currentPage: 1,
      perPage: 10,
      sortField: 'FULLNAME',
      sortOrder: 'ASC',
    };
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'manageUsers',
        activeMenu: this.activeMenu ? this.activeMenu : 'security',
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.$store
        .dispatch('manageSystemUsers/fetchAllSystemUsers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    searchUsers() {
      this.loading = true;
      this.currentPage = 1;
      this.$store
        .dispatch('manageSystemUsers/fetchAllSystemUsers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    sortUsers() {
      this.loading = true;
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      this.$store
        .dispatch('manageSystemUsers/fetchAllSystemUsers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    getUsers() {
      this.loading = true;
      this.currentPage = 1;
      this.$store
        .dispatch('manageSystemUsers/fetchAllSystemUsers', {
          searchTerm: this.searchTerm,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        })
        .then(() => {
          this.loading = false;
        });
    },
    deleteUser(id) {
      this.$confirm({
        title: 'Delete User',
        content: 'This user will be permanently deleted and cannot be recovered. Are you sure?',
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          this.$store
            .dispatch('manageSystemUsers/removeSystemUser', {
              userId: id,
            })
            .then(() => {
              this.resetUsers();
            });
        },
      });
    },
    resetUsers() {
      this.loading = true;
      this.$store
        .dispatch('manageSystemUsers/fetchAllSystemUsers', {
          searchTerm: '',
          pageNumber: 1,
          pageSize: 10,
          sortField: '',
          sortOrder: '',
        })
        .then(() => {
          this.loading = false;
        });
    },
  },

  computed: {
    allUsers() {
      return this.$store.getters['manageSystemUsers/allSystemUsers'];
    },
    sortOrderClass() {
      return this.sortOrder === 'ASC' ? 'asc' : 'desc';
    },
    passwordCheckFailed() {
      return this.$store.getters['manageSystemUsers/passwordCheckFailed'];
    },
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch('manageSystemUsers/fetchAllSystemUsers', {
        searchTerm: this.searchTerm,
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      })
      .then(() => {
        this.loading = false;
      });
  },

  created() {
    this.setActiveMenuItem();
  },

  destroyed() {
    this.$store.commit('manageSystemUsers/SET_PASSWORD_CHECK', false);
  },
};
</script>
<style lang="scss" scoped>
.manage-users {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

.centered {
  position: fixed;
  top: 62%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
}

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}

.white-space {
  white-space: nowrap !important;
}

html,
body {
  height: 100%;
}
</style>
